export enum SignalStatusTypes {
  ACCEPTED = 1,
  FALSE_ALARM = 2,
  PROCESSING = 3,
  CHECKING = 4,
  CLOSED_ISSUE_IDENTIFIED = 5,
  CLOSED_ISSUE_NOT_IDENTIFIED = 6
}
